
import { calculateRepeatAnswers } from "./calculateRepeatAnswers"
import { sortAllQuestionAnswersForCheckPeriod } from "./sortAllQuestionAnswersForCheckPeriod"



const isAnswerLocked = (questionAnswer) => {
  if (questionAnswer && questionAnswer['LockedUntil']) {
    const currentTimeStamp = new Date().getTime()
    const lockedUntilTimeStamp = questionAnswer['LockedUntil']
    const dateDiffValue = lockedUntilTimeStamp - currentTimeStamp
    if (dateDiffValue > 0) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const canUserAddExtraAnswers = (currentQuestionAnswerId, allQuestionAnswersArray, tableData) => {
  // question is a repeating question, or the last child question of a repeating question
  // if its possible to add more answers to the question, prompt for this
  const thisAnswer = tableData && tableData.ChecklistAnswers && tableData.ChecklistAnswers[currentQuestionAnswerId]
  const questionForThisAnswer = thisAnswer && thisAnswer.questionId && tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[thisAnswer.QuestionId]
  let ParentAnswerId = thisAnswer && thisAnswer.ParentAnswerId || thisAnswer?.Id
  const ParentAnswer = tableData && tableData.ChecklistAnswers && ParentAnswerId && tableData.ChecklistAnswers[ParentAnswerId]
  const parentQuestionId = ParentAnswerId && tableData['ChecklistAnswers'] && tableData['ChecklistAnswers'][ParentAnswerId] && tableData['ChecklistAnswers'][ParentAnswerId]['QuestionId']
  const parentQuestionForThisAnswer = tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[parentQuestionId]
  let isParentARepeatingQuestion = false
  let isQuestionARepeatingQuestion = false

  if (parentQuestionForThisAnswer && parentQuestionForThisAnswer.RepeatQuestion && Object.keys(parentQuestionForThisAnswer.RepeatQuestion).length > 0) {
    isParentARepeatingQuestion = true
  }
  if (questionForThisAnswer && questionForThisAnswer.RepeatQuestion && Object.keys(questionForThisAnswer.RepeatQuestion).length > 0) {
    isQuestionARepeatingQuestion = true
  }


  if (isQuestionARepeatingQuestion === false && isParentARepeatingQuestion === false) {
    return false
  }

  //console.log("this is either a  repeating questior or a child question of a repeating question")
  const whichQuestionRepeats = isParentARepeatingQuestion ? parentQuestionForThisAnswer : questionForThisAnswer
  //console.log(isParentARepeatingQuestion? "Parent question is repeating" : "Question is repeating")

  const pendingFollowonAnswers = allQuestionAnswersArray.filter((answer) => {
    // console.log("Checking for pending follow on answers")
    // console.log("answer.Pending", answer.Pending)
    // console.log("answer.ParentAnswerId", answer.ParentAnswerId)
    // console.log(answer)
    return (answer.Pending === true && answer.ParentAnswerId === ParentAnswerId)
  })


  if (pendingFollowonAnswers.length > 0) {
    //console.log("This question has pending follow on answers")
    return false
  }

  // check for pending repeat answers, i.e. differen answer id but same question id 
  const pendingRepeatAnswers = allQuestionAnswersArray.filter((answer) => {
    // console.log("Checking for pending repeat answers")
    // console.log("answer.Pending", answer.Pending)
    // console.log("answer.QuestionId", answer.QuestionId)
    return (answer.Pending === true && answer.QuestionId === whichQuestionRepeats.Id && answer.Id !== currentQuestionAnswerId)
  })

  if (pendingRepeatAnswers.length > 0) {
    //console.log("This question has pending repeat answers")
    return false
  }

  const followonAnswers = allQuestionAnswersArray.filter((answer) => {
    return (answer.ParentAnswerId === ParentAnswerId)
  })

  if (followonAnswers.length > 0 && ParentAnswerId == currentQuestionAnswerId) {
    //console.log("This is a parent question and it has has follow on answers")
    return false
  }


  if (followonAnswers.length > 0) {
    const thisAnswer = tableData && tableData.ChecklistAnswers && tableData.ChecklistAnswers[currentQuestionAnswerId]
    const questionPosition = followonAnswers.indexOf(thisAnswer)
    const followOnAnswersLisLength = followonAnswers.length
    const isLastFollowOnAnswer = questionPosition === followOnAnswersLisLength - 1
    if (!isLastFollowOnAnswer) {
      //console.log("This is the last follow on answer")
      return false
    }

  }

  const { maxRepeatAnswersForThisQuestion, repeatAnswersForThisQuestion } = calculateRepeatAnswers(allQuestionAnswersArray, whichQuestionRepeats)

  // console.log("maxRepeatAnswersForThisQuestion", maxRepeatAnswersForThisQuestion)
  // console.log("repeatAnswersForThisQuestion", repeatAnswersForThisQuestion)


  if (repeatAnswersForThisQuestion < maxRepeatAnswersForThisQuestion) {
    //console.log("YES - This question can have more answers")
    return true
  }

  if (repeatAnswersForThisQuestion >= maxRepeatAnswersForThisQuestion - 1) {
    //console.log("This question has reached the maximum number of repeat answers")
    return false
  }
  console.log("No - all logic has failed")
  return false
}


export const findNextQuestionUrl = (currentQuestionAnswerId, checkPeriodId, tableData, behaviour = '') => {

  let returnUrl = `/checklists/${checkPeriodId}`

  const checklistPeriod = tableData && tableData.ChecklistPeriods && tableData.ChecklistPeriods[checkPeriodId]
  const checklistId = checklistPeriod && checklistPeriod.ChecklistId
  const thisChecklist = tableData && tableData.Checklists && checklistId && tableData.Checklists[checklistId]
  const isExternalVisitorChecklist = thisChecklist && thisChecklist.userAccess && thisChecklist.userAccess.type && thisChecklist.userAccess.type === "externalIndividual"
  const isSignoffRequiredForOrg = tableData && tableData['Organisation'] && tableData['Organisation']['ChecklistOptions'] && tableData['Organisation']['ChecklistOptions']['RequireSignoff'] && tableData['Organisation']['ChecklistOptions']['RequireSignoff'] === true ? true : false


  // console.log(`Is external user checklist? ${isExternalVisitorChecklist ? "✅" : "❌"}`)
  // console.log(`Is signoff required for org? ${isSignoffRequiredForOrg ? "✅" : "❌"}`)

  // back to main page if no check period id or table data
  if (!checkPeriodId || !tableData) {
    returnUrl = '/'
  } else {

    // get all question answers for this check period
    const allQuestionAnswersArray = sortAllQuestionAnswersForCheckPeriod(checkPeriodId, tableData)

    // filter out any answers that are not pending
    // count any answers that are locked
    let availableAnswers = []
    let lockedAnswers = []
    allQuestionAnswersArray.forEach((answer) => {
      const isThisAnswerLocked = isAnswerLocked(answer)
      if (answer.Pending === true) {
        if (isThisAnswerLocked) {
          lockedAnswers.push(answer)
        } else {
          availableAnswers.push(answer)
        }
      }
    })

    // if no current answer is provided, return the first in the list
    if (!currentQuestionAnswerId && availableAnswers[0]) {
      const answerId = availableAnswers[0].Id
      returnUrl = `/checklists/${checkPeriodId}/${answerId}`
    }

    // if an answer is provided...
    else if (currentQuestionAnswerId) {

      // if the behaviour is confirm, return the confirm page
      if (behaviour === 'confirm') {
        returnUrl = `/checklists/${checkPeriodId}/confirm/${currentQuestionAnswerId}`
      } else {

        const thisAnswer = tableData && tableData.ChecklistAnswers && tableData.ChecklistAnswers[currentQuestionAnswerId]
        const questionId = thisAnswer ? thisAnswer.QuestionId : null


        const promptToAddNewAnswer = canUserAddExtraAnswers(currentQuestionAnswerId, allQuestionAnswersArray, tableData)
        const already_on_add_page = window.location.pathname.includes('/add-answer/')
        if (promptToAddNewAnswer && !already_on_add_page) {
          returnUrl = `/checklists/${checkPeriodId}/add-answer/${questionId}`
        }

        else {

          // otherwise, find the remaining pending answers
          const filteredAnswersArray = allQuestionAnswersArray.filter((answer) => {
            return (answer.Pending === true && !isAnswerLocked(answer)) || answer.Id === currentQuestionAnswerId
          })
          const currentAnswerIndex = filteredAnswersArray.findIndex((answer) => answer.Id === currentQuestionAnswerId)
          const pendingAnswersBeforeThisOne = filteredAnswersArray.slice(0, currentAnswerIndex)
          const pendingAnswersAfterThisOne = filteredAnswersArray.slice(currentAnswerIndex + 1)


          // if there is a pending answer after this, proceed
          if (pendingAnswersAfterThisOne.length > 0) {
            const answerId = pendingAnswersAfterThisOne[0].Id
            returnUrl = `/checklists/${checkPeriodId}/${answerId}`
          } else {

            // if there are no pending answers after this, check if there are any pending answers before this
            if (pendingAnswersBeforeThisOne.length > 0) {
              const answerId = pendingAnswersBeforeThisOne[0].Id
              returnUrl = `/checklists/${checkPeriodId}/${answerId}`
            } else {
              // if there are no pending answers, go back to the checklist
              if (lockedAnswers.length > 0) {
                returnUrl = `/checklists/${checkPeriodId}/`
              } else {
                //console.log("Finding next question url - This is where it should check for sign off")
                // external visitor checklists are never signed off
                if (isSignoffRequiredForOrg && !isExternalVisitorChecklist) {
                  returnUrl = `/checklists/${checkPeriodId}/complete-checklist`
                } else {

                  if (isExternalVisitorChecklist) {
                    returnUrl = `/`
                  } else {
                    returnUrl = `/checklists/${checkPeriodId}/`
                  }

                }
              }
            }
          }
        }
      }
    }
  }

  return returnUrl

}